import { Injectable } from '@angular/core';
import { BaseOrganizationViewmodel } from 'edu-application/dist/organization/base/base.organization.viewmodel';
import { GroupsService } from '../groups.service';
import { OrganizationService } from '../organization.service';
import { SwitchOverlayService } from '../switch-overlay/switch-overlay.service';
import { StudentsService } from '../../students/students.service';
import {
  navigateAfterOrgSwitch,
  ORG_SWITCH_NAVIGATION_DELAY_MS,
} from './org-switch-navigation.util';

@Injectable({ providedIn: 'root' })
export class OrgSwitchService {
  constructor(
    private orgService: OrganizationService,
    private switchOverlay: SwitchOverlayService,
  ) {}

  trigger(org: BaseOrganizationViewmodel): void {
    this.orgService.selectOrganization(org.id);
    StudentsService.clearCache();
    GroupsService.clearCache();
    this.switchOverlay.show({
      logoUrl: org.logoUrl,
      title: org.displayName ?? org.name,
      primaryColor: org.primaryColor,
    });
    setTimeout(() => navigateAfterOrgSwitch(), ORG_SWITCH_NAVIGATION_DELAY_MS);
  }
}
